// extracted by mini-css-extract-plugin
export default {"cardText":"style_cardText__v0Hiy"};